import { IOrganisationUser, IOrganisationUserEdit } from '@liquid-state/pephealth-client';

export interface DirectChildOrganisationUserEditValues {
  firstName: string;
  lastName: string;
  language: string;
  phoneNumber: string;
  careTeamMember: boolean;
}

export const toDirectChildOrganisationUserEdit = (
  currentUser: IOrganisationUser,
  values: DirectChildOrganisationUserEditValues,
): IOrganisationUserEdit => {
  const edit: IOrganisationUserEdit = {};

  if (values.firstName !== currentUser.firstName) edit.firstName = values.firstName;
  if (values.lastName !== currentUser.lastName) edit.lastName = values.lastName;
  if (values.language !== currentUser.language) edit.language = values.language;
  if (values.phoneNumber !== (currentUser.phoneNumber || '')) {
    edit.phoneNumber = values.phoneNumber;
  }
  if (values.careTeamMember !== currentUser.careTeamMember) {
    edit.careTeamMember = values.careTeamMember;
  }

  return edit;
};
